// Author Lin
// Date 2021-10-11 12:03:56

import * as model from "@/model/mintalMes/prd/MintalMesPrdSmeltingFurnacePowerFailureRecordModel.js";
import {newEntityStoreHelper} from "@/store/common/entityModule";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}

export default newEntityStoreHelper(() => new model.MintalMesPrdSmeltingFurnacePowerFailureRecord(),newFilter)
    .withStates({
        baseModuleUrl: process.env.VUE_APP_MINTALMES_PRD_URL,
    })
    .buildStore()
